"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable */
var _default = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M8.4142 3.5858L7 5H5C3.3432 5 2 6.3431 2 8v9c0 1.6569 1.3432 3 3 3h14c1.6569 0 3-1.3431 3-3V8c0-1.6569-1.3431-3-3-3h-2l-1.4142-1.4142A2 2 0 0014.1716 3H9.8284a2 2 0 00-1.4142.5858zM4 17V8c0-.5523.4477-1 1-1h2.8284l2-2h4.3432l2 2H19c.5523 0 1 .4477 1 1v9c0 .5523-.4477 1-1 1H5c-.5523 0-1-.4477-1-1zm8-3c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2zm-4-2c0 2.2091 1.7909 4 4 4 2.2091 0 4-1.7909 4-4 0-2.2091-1.7909-4-4-4-2.2091 0-4 1.7909-4 4z",
  clipRule: "evenodd"
})), 'CameraIcon');
/* eslint-enable */


exports["default"] = _default;